import script from "./SportsCats.vue?vue&type=script&lang=js"
export * from "./SportsCats.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__